/**
 * Maps the icon name strings returned by the backend `/api/me/sidebar/`
 * endpoint to lucide-react components. Keep this in sync with the `icon`
 * values in setu_backend/config/fixture/side_bar.json.
 *
 * Unknown icon names fall back to `Circle` so a new backend item never
 * renders blank.
 */
import {
  LayoutDashboard,
  MessageSquare,
  Users,
  Users2,
  FileText,
  Megaphone,
  GitBranch,
  ListChecks,
  Kanban,
  Headphones,
  Bot,
  BookOpen,
  BarChart3,
  ArrowUpDown,
  ShoppingBag,
  Puzzle,
  Wallet,
  Settings,
  LifeBuoy,
  BookText,
  SmilePlus,
  Activity,
  Images,
  Circle,
  // Settings tab icons (is_tabbing items)
  User,
  Building2,
  Shield,
  MessageCircle,
  Ban,
  MessageSquareText,
  KeyRound,
  CreditCard,
  Webhook,
  type LucideIcon,
} from 'lucide-react'

export const SIDEBAR_ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  MessageSquare,
  Users,
  Users2,
  FileText,
  Megaphone,
  GitBranch,
  ListChecks,
  Kanban,
  Headphones,
  Bot,
  BookOpen,
  BarChart3,
  ArrowUpDown,
  ShoppingBag,
  Puzzle,
  Wallet,
  Settings,
  LifeBuoy,
  BookText,
  SmilePlus,
  Activity,
  Images,
  // Settings tabs
  User,
  Building2,
  Shield,
  MessageCircle,
  Ban,
  MessageSquareText,
  KeyRound,
  CreditCard,
  Webhook,
}

/** Resolve an icon name string to a component, falling back to `Circle`. */
export function resolveSidebarIcon(name: string | undefined | null): LucideIcon {
  if (name && SIDEBAR_ICONS[name]) return SIDEBAR_ICONS[name]
  return Circle
}
